import React from 'react';

const IconKalkulator = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7H13C13.5523 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5H11Z"
        fill="#06090D"
      />
      <path
        d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="#06090D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2H7ZM17 4V14L7 14V4L17 4ZM17 16L7 16L7 20H17V16Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconKalkulator;
